import { useCallback } from 'react';
import { useCompStyleElementObserver } from '@wix/thunderbolt-elements/providers/useCompStyleElementObserver';
import { updateDropdownDomStyles } from '../components/MenuItem/updateDropdownDomStyles';
import { MenuParts } from '../constants';

export const useUpdateDropdownPosition = (
  id: string,
  shownDropdownId: string | undefined,
) => {
  const updateDropdownPosition = useCallback(() => {
    const itemEl = document
      .getElementById(id)
      ?.querySelector(`[data-part="${MenuParts.MenuItem}"][data-open="true"]`);

    if (itemEl) {
      updateDropdownDomStyles(itemEl as HTMLElement, false);
    }
  }, [id]);

  useCompStyleElementObserver({
    compIds: [id, shownDropdownId].filter(Boolean) as Array<string>,
    shouldObserve: !!shownDropdownId,
    callback: updateDropdownPosition,
  });
};
